import { render, staticRenderFns } from "./hover-overlay.vue?vue&type=template&id=1d91ace5&scoped=true&"
import script from "./hover-overlay.vue?vue&type=script&lang=ts&"
export * from "./hover-overlay.vue?vue&type=script&lang=ts&"
import style0 from "./hover-overlay.vue?vue&type=style&index=0&id=1d91ace5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d91ace5",
  null
  
)

export default component.exports